import analytics from '@ublend-npm/aula-analytics';
import { useCallback } from 'react';
import { useAulaEditorContext } from '../EditorContext';
import { AulaEditorContext } from '../types';

type EventName =
  | 'START_VOICE_RECORDING'
  | 'STOP_VOICE_RECORDING'
  | 'START_AUDIO_PLAYER'
  | 'STOP_AUDIO_PLAYER'
  | 'COLLAPSE_FILE_BLOCK'
  | 'EXPAND_FILE_BLOCK'
  | 'DISCARD_VOICE_RECORDING'
  | 'UPLOAD_VOICE_RECORDING'
  | 'ALT_TEXT_UPDATED'
  | 'ALT_TEXT_UPDATE_CANCELLED'
  | 'ADD_EDITOR_TEMPLATE'
  | 'OPEN_EDITOR_TEMPLATES'
  | 'CLOSE_EDITOR_TEMPLATES'
  | 'ATTEMPT_TO_NEST_LIST'
  | 'LTI_BLOCK_LAUNCH'
  | 'LTI_ASSIGNMENT_LAUNCH'
  | 'DEEPLINKING_HELP'
  | 'OPEN_DEEPLINKING_MODAL'
  | 'CLOSE_DEEPLINKING_MODAL'
  | 'EDITOR_PASTE_CONTENT';

type CommonTrackingInfo = {
  itemType?: string;
  provider?: string;
};

export type AdditionalTrackingInformation =
  | {
      itemType: 'assignment';
      assignmentId: string;
      provider: string;
    }
  | ({
      templateId: string;
      templateVersion: string;
    } & CommonTrackingInfo)
  | ({
      pasteSource: string;
    } & CommonTrackingInfo)
  | CommonTrackingInfo;

export const getAnalyticsEvent = (
  event: EventName,
  context: AulaEditorContext,
  additionalTrackingInfo?: AdditionalTrackingInformation,
) => ({
  activeClassroom: context.config.spaceId,
  event,
  userId: context.config.userId,
  assignmentId: context.config.assignmentId,
  postId: context.config.postId,
  conversationId: context.config.conversationId,
  entityType: context.contentType,
  isInstructor: context.config.isEducator,
  itemType: context.config.itemType,
  correlationId: context.config.correlationId,
  itemId: context.config.itemId,
  ...additionalTrackingInfo,
});

export const useAnalytics = () => {
  const context = useAulaEditorContext();

  const track = useCallback(
    (
      event: EventName,
      additionalTrackingInfo?: AdditionalTrackingInformation,
    ) => {
      analytics.track(
        getAnalyticsEvent(event, context, additionalTrackingInfo),
      );
    },
    [context],
  );

  return track;
};
